import { ISettingsState } from "@reducers/settings.reducer";
import { SidebarLink } from "@clockwise/web-commons/src/ui/scheduling-links-sidebar";

export enum IOnboardingChecklistSyncType {
  slackEnabled = "SlackEnabled",
  inviteSent = "InviteSent",
}
export enum SettingsActions {
  SetUserTeam = "Settings_SetUserTeam",
  ToggleExpanded = "Settings_ToggleExpanded",
  CloseSettingsDrawers = "Settings_Close_Drawers",
  OpenTeam = "Settings_OpenTeam",
  ResetTeamId = "Settings_ResetTeamId",
  OpenPersonalCalendar = "Settings_OpenPersonalCalendar",
  OpenRooms = "Settings_OpenRooms",
  UpdatePreferredRoomsMillis = "Settings_UpdatePreferredRoomsMillis",
  OpenIntegrations = "Settings_OpenIntegrations",
  OpenInvites = "Settings_OpenInvites",
  OpenSmartHolds = "Settings_OpenSmartHolds",
  OpenLunch = "Settings_OpenLunch",
  SetCloseAfterSaving = "Settings_SetCloseAfterSaving",
  SetRequireSaveHours = "Settings_SetRequireSaveHours",
  TriggerSaveHours = "Settings_TriggerSaveHours",
  SetRequireSaveFocusTimeSync = "Settings_SetRequireSaveFocusTimeSync",
  TriggerSaveFocusTimeSync = "Settings_TriggerSaveFocusTimeSync",
  SetRequireSaveLunchSync = "Settings_SetRequireSaveLunchSync",
  TriggerSaveLunchSync = "Settings_TriggerSaveLunchSync",
  SetRequireSaveTravelTimeSync = "Settings_SetRequireSaveTravelTimeSync",
  TriggerSaveTravelTimeSync = "Settings_TriggerSaveTravelTimeSync",
  SendInvite = "Settings_SendInvite",
  OpenPaidPlans = "Settings_OpenPaidPlans",
  SetSchedulingLinks = "Settings_SetSchedulingLinks",
  SetLinkName = "Settings_SetLinkName",
  SetSavedOnboardingChecklistSyncType = "Settings_SetSavedOnboardingChecklistSyncType",
}

export interface ISettingsAction {
  type: SettingsActions;
  data?: any;
}

export const setUserTeam = (userTeamCalendarIds: string[]): ISettingsAction => ({
  type: SettingsActions.SetUserTeam,
  data: userTeamCalendarIds,
});

export const toggleExpanded = (stateKey: keyof ISettingsState): ISettingsAction => ({
  type: SettingsActions.ToggleExpanded,
  data: stateKey,
});

export const closeSettingsDrawers = (): ISettingsAction => ({
  type: SettingsActions.CloseSettingsDrawers,
});

export const openTeam = (
  teamId?: string,
  subTabIndex?: number,
  feature?: string,
  teamCreateOrJoin?: string,
): ISettingsAction => ({
  type: SettingsActions.OpenTeam,
  data: {
    teamSettingsId: teamId ? teamId : "",
    subTabIndex: subTabIndex ? subTabIndex : -1,
    teamSettingsFeature: feature ? feature : "",
    teamSettingsCreateOrJoin: teamCreateOrJoin ? teamCreateOrJoin : "",
  },
});

export const resetTeamId = (): ISettingsAction => ({
  type: SettingsActions.ResetTeamId,
});

export const openRooms = (): ISettingsAction => ({
  type: SettingsActions.OpenRooms,
});

export const updatePreferredRoomsMillis = (): ISettingsAction => ({
  type: SettingsActions.UpdatePreferredRoomsMillis,
});

export const openIntegrations = (): ISettingsAction => ({
  type: SettingsActions.OpenIntegrations,
});

export const openPersonalCalendar = (): ISettingsAction => ({
  type: SettingsActions.OpenPersonalCalendar,
});

export const openInvites = (): ISettingsAction => ({
  type: SettingsActions.OpenInvites,
});

export const openSmartHolds = (): ISettingsAction => ({
  type: SettingsActions.OpenSmartHolds,
});

export const openLunch = (): ISettingsAction => ({
  type: SettingsActions.OpenLunch,
});

export const openPaidPlans = (): ISettingsAction => ({
  type: SettingsActions.OpenPaidPlans,
});

export const setCloseAfterSaving = (closeAfterSaving: boolean): ISettingsAction => ({
  type: SettingsActions.SetCloseAfterSaving,
  data: closeAfterSaving,
});

export const setRequireSaveHours = (requireSaveHours: boolean): ISettingsAction => ({
  type: SettingsActions.SetRequireSaveHours,
  data: requireSaveHours,
});

export const triggerSaveHours = (): ISettingsAction => ({
  type: SettingsActions.TriggerSaveHours,
});

export const setRequireSaveFocusTimeSync = (
  requireSaveFocusTimeSync: boolean,
): ISettingsAction => ({
  type: SettingsActions.SetRequireSaveFocusTimeSync,
  data: requireSaveFocusTimeSync,
});

export const triggerSaveFocusTimeSync = (): ISettingsAction => ({
  type: SettingsActions.TriggerSaveFocusTimeSync,
});

export const setRequireSaveLunchSync = (requireSaveLunchSync: boolean): ISettingsAction => ({
  type: SettingsActions.SetRequireSaveLunchSync,
  data: requireSaveLunchSync,
});

export const setSavedOnboardingChecklistSyncType = (
  savedOnboardingChecklistSyncType: string,
): ISettingsAction => ({
  type: SettingsActions.SetSavedOnboardingChecklistSyncType,
  data: savedOnboardingChecklistSyncType,
});

export const triggerSaveLunchSync = (): ISettingsAction => ({
  type: SettingsActions.TriggerSaveLunchSync,
});

export const setRequireSaveTravelTimeSync = (
  requireSaveTravelTimeSync: boolean,
): ISettingsAction => ({
  type: SettingsActions.SetRequireSaveTravelTimeSync,
  data: requireSaveTravelTimeSync,
});

export const triggerSaveTravelTimeSync = (): ISettingsAction => ({
  type: SettingsActions.TriggerSaveTravelTimeSync,
});

export const sendInvite = (email: string): ISettingsAction => ({
  type: SettingsActions.SendInvite,
  data: email,
});

export const setSchedulingLinks = (schedulingLinks: SidebarLink[]): ISettingsAction => ({
  type: SettingsActions.SetSchedulingLinks,
  data: schedulingLinks,
});

export const setLinkName = (linkName: string): ISettingsAction => ({
  type: SettingsActions.SetLinkName,
  data: linkName,
});
